import React from 'react';
import ClientControlCentral from "./ClientControlCentral";

/**
 * Ruta base /client/:id — muestra Panel (Control Central) para todos los usuarios.
 * UX 2.0: Panel es ahora el tab default.
 */
export default function ClientDefaultRoute() {
    return <ClientControlCentral/>;
}
